import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { AuthProvider } from '@lusha/auth-client-sdk';
import { observer } from 'mobx-react';
import React, { Suspense } from 'react';
import Modal from 'react-modal';
import { MemoryRouter, Route, Routes } from 'react-router-dom';
import { createGlobalStyle } from 'styled-components';
import AppContext from './AppContext';
import AppInt from './AppInt';
import AppParser from './AppParser';
import AppUserContext from './AppUserContext';
import RateExtensionModal from './modals/rate-extension/RateExtensionModal';
import UpgradePlanModal from './modals/upgrade-plan/UpgradePlanModal';
import { listenCorePluginBIEvents } from './utils/BIEvents/corePluginEventsHandler';
import lazyRetryReload from './utils/lazyRetryReload';
const Master = lazyRetryReload(() => import(/* webpackChunkName: "Master" */ './layout/Master/Master'), 'Master');
const GmailOnboarding = lazyRetryReload(() => import(/* webpackChunkName: "GmailOnboarding" */ './views/GmailOnboarding'), 'GmailOnboarding');
const EnablePermissions = lazyRetryReload(() => import(/* webpackChunkName: "EnablePermissions" */ './views/EnablePermissions'), 'EnablePermissions');
const ToolbarPopup = lazyRetryReload(() => import(/* webpackChunkName: "Toolbar" */ './views/ToolbarPopup'), 'Toolbar');
const IntegrationCompleted = lazyRetryReload(() => import(/* webpackChunkName: "IntegrationCompleted" */ './views/IntegrationCompleted'), 'IntegrationCompleted');
listenCorePluginBIEvents();
const modalRootElement = document.getElementById('modals');
Modal.setAppElement(modalRootElement);
const InterFont = createGlobalStyle `
  * {
    font-family: Inter !important;
  }
`;
const AppRoutes = observer(() => (_jsxs(_Fragment, { children: [envConfig.FEATURES.NEW_INTER_FONT ? _jsx(InterFont, {}) : null, _jsxs(Routes, { children: [_jsx(Route, { path: "gmail-onboarding", element: _jsx(GmailOnboarding, {}) }), _jsx(Route, { path: "enable-permissions", element: _jsx(EnablePermissions, {}) }), _jsx(Route, { path: "toolbar-popup", element: _jsx(ToolbarPopup, {}) }), _jsx(Route, { path: "integration-completed", element: _jsx(IntegrationCompleted, {}) }), _jsx(Route, { path: "*", element: _jsx(Master, {}) })] })] })));
function App() {
    return (_jsx(AuthProvider, { shouldCacheUser: true, children: _jsx(AppContext, { children: _jsx(Suspense, { fallback: null, children: _jsx(MemoryRouter, { initialEntries: [window.document.location], children: _jsx(AppUserContext, { children: _jsx(AppInt, { children: _jsxs(AppParser, { children: [_jsx(AppRoutes, {}), _jsx(RateExtensionModal, {}), _jsx(UpgradePlanModal, {})] }) }) }) }) }) }) }));
}
export default App;
